// 로그인 후 매장그룹 데이터
export const TestGroupList = [
	{
		groupId: '1', groupName: 'グループ1',
		storeList: [
			{ storeId: '1', storeName: '吉祥寺店' },
			{ storeId: '2', storeName: '吉祥寺北口店' },
			{ storeId: '3', storeName: '武蔵境店' },
		],
	},
	{ groupId: '2', groupName: 'グループ2',
		storeList: [
			{ storeId: '1', storeName: '吉祥寺店' },
			{ storeId: '2', storeName: '吉祥寺北口店' },
		],
	},
	{
		groupId: '3', groupName: 'グループ3',
		storeList: [
			{ storeId: '1', storeName: '吉祥寺店' },
			{ storeId: '2', storeName: '吉祥寺北口店' },
			{ storeId: '3', storeName: '武蔵境店' },
		],
	},
	{ groupId: '4', groupName: 'グループ4',
		storeList: [
			{ storeId: '1', storeName: '吉祥寺店' },
			{ storeId: '2', storeName: '吉祥寺北口店' },
		],
	},
	{
		groupId: '5', groupName: 'グループ5',
		storeList: [
			{ storeId: '1', storeName: '吉祥寺店' },
			{ storeId: '2', storeName: '吉祥寺北口店' },
			{ storeId: '3', storeName: '武蔵境店' },
		],
	},
	{
		groupId: '6', groupName: 'グループ6',
		storeList: [
			{ storeId: '1', storeName: '吉祥寺店' },
			{ storeId: '2', storeName: '吉祥寺北口店' },
			{ storeId: '3', storeName: '武蔵境店' },
		],
	},
];
// 대시보드 차트 데이터
export const ChartData = {
	labels: ["オンライン", "オフライン"],
	datasets: [
		{
			label: "オンライン",
			backgroundColor: ["#008DD0", "#6A6A6A"],
			data: [385, 78],
			borderWidth: 0,
			borderColor: 'transparent',
			hoverOffset: 10
		}
	]
};
export const ChartData2 = {
	labels: ["オンライン", "オフライン"],
  datasets: [
    {
      label: "オンライン",
      backgroundColor: ["#008DD0", "#6A6A6A"],
      data: [34, 4],
			borderWidth: 0,
			borderColor: 'transparent',
			hoverOffset: 10
    }
  ]
};
// 매장검색 트리뷰 데이터
export const BrandListTest = {
	brands: [
		{ brandCd: 'P000001', brandName: 'スターバックス', count: 100 },
		{ brandCd: 'P000002', brandName: 'エクセルシオールカフェ', count: 200 },
		{ brandCd: 'P000003', brandName: 'ドトールコーヒー', count: 50 },
		{ brandCd: 'P000004', brandName: 'ブランド3', count: 100 },
		{ brandCd: 'P000005', brandName: 'ブランド4', count: 70 },
		{ brandCd: 'P000006', brandName: 'ブランド5', count: 120 },
	]
};
// 매장검색 결과 점포리스트
export const StoreList = [
	{
		storeId: '1',
		storeName: '吉祥寺店'
	},
	{
		storeId: '2',
		storeName: '吉祥寺北口店'
	},
	{
		storeId: '3',
		storeName: '武蔵境店'
	},
]
// 매장검색 결과 차트 데이터
export const ChartData3 = {
	labels: ["07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00"
		, "15:00", "16:00", "17:00", "20:00", "21:00", "22:00", "23:00", "24:00" ],
	datasets: [
		{
			backgroundColor: "#008DD0",
			data: [385, 526, 735, 832, 874, 921, 964, 995, 1023, 1067, 1274, 1467,
				864, 424, 534, 421],
			borderWidth: 0,
			borderColor: 'transparent',
			hoverOffset: 10
		},
		{
			backgroundColor: "#6A6A6A",
			data: [163, 637, 832, 953, 632, 1025, 1267, 1352, 1279, 1798, 732, 621,
				789, 425, 325, 189],
			borderWidth: 0,
			borderColor: 'transparent',
			hoverOffset: 10
		},
	]
};
// 타매장 분석 데이터
export const OtherStoreDatas = [
	{ chartData: {
			labels: ["オンライン", "オフライン"],
			datasets: [
				{
					label: "オンライン",
					backgroundColor: ["#008DD0", "#6A6A6A"],
					data: [385, 78],
					borderWidth: 0,
					borderColor: 'transparent',
					hoverOffset: 10
				}
			]
		}
	},
	{ chartData: {
			labels: ["オンライン", "オフライン"],
			datasets: [
				{
					label: "オンライン",
					backgroundColor: ["#008DD0", "#6A6A6A"],
					data: [100, 78],
					borderWidth: 0,
					borderColor: 'transparent',
					hoverOffset: 10
				}
			]
		}
	},
	{ chartData: {
			labels: ["オンライン", "オフライン"],
			datasets: [
				{
					label: "オンライン",
					backgroundColor: ["#008DD0", "#6A6A6A"],
					data: [181, 16],
					borderWidth: 0,
					borderColor: 'transparent',
					hoverOffset: 10
				}
			]
		}
	},
	{ chartData: {
			labels: ["オンライン", "オフライン"],
			datasets: [
				{
					label: "オンライン",
					backgroundColor: ["#008DD0", "#6A6A6A"],
					data: [145, 52],
					borderWidth: 0,
					borderColor: 'transparent',
					hoverOffset: 10
				}
			]
		}
	},
	{ chartData: {
			labels: ["オンライン", "オフライン"],
			datasets: [
				{
					label: "オンライン",
					backgroundColor: ["#008DD0", "#6A6A6A"],
					data: [124, 150],
					borderWidth: 0,
					borderColor: 'transparent',
					hoverOffset: 10
				}
			]
		}
	},
	{ chartData: {
			labels: ["オンライン", "オフライン"],
			datasets: [
				{
					label: "オンライン",
					backgroundColor: ["#008DD0", "#6A6A6A"],
					data: [133, 36],
					borderWidth: 0,
					borderColor: 'transparent',
					hoverOffset: 10
				}
			]
		}
	},
	{ chartData: {
			labels: ["オンライン", "オフライン"],
			datasets: [
				{
					label: "オンライン",
					backgroundColor: ["#008DD0", "#6A6A6A"],
					data: [145, 52],
					borderWidth: 0,
					borderColor: 'transparent',
					hoverOffset: 10
				}
			]
		}
	},
	{ chartData: {
			labels: ["オンライン", "オフライン"],
			datasets: [
				{
					label: "オンライン",
					backgroundColor: ["#008DD0", "#6A6A6A"],
					data: [100, 78],
					borderWidth: 0,
					borderColor: 'transparent',
					hoverOffset: 10
				}
			]
		}
	},
	{ chartData: {
			labels: ["オンライン", "オフライン"],
			datasets: [
				{
					label: "オンライン",
					backgroundColor: ["#008DD0", "#6A6A6A"],
					data: [181, 16],
					borderWidth: 0,
					borderColor: 'transparent',
					hoverOffset: 10
				}
			]
		}
	},
];
// 매장그룹 생성 선택된 매장 List 데이터
export const SelectedStoreList = [
	{ name: '新宿店' },
	{ name: '東京店' },
	{ name: '大阪店' },
	{ name: '中野店' },
	{ name: '新宿店' },
	{ name: '東京店' },
	{ name: '大阪店' },
	{ name: '中野店' },
	{ name: '新宿店' },
	{ name: '東京店' },
	{ name: '大阪店' },
	{ name: '中野店' },
	{ name: '新宿店' },
	{ name: '東京店' },
	{ name: '大阪店' },
	{ name: '中野店' },
]
// 매장그룹 생성 매장검색 데이터
export const SearchTestStoreList = [
	{
		id: 1, name: '東京都都下 (132)',
		children: [
			{ id: 2, name: '吉祥寺店' },
			{ id: 3, name: '三鷹店' },
			{ id: 4, name: '武蔵境店' },
			{ id: 5, name: '東小金井店' },
			{ id: 6, name: '武蔵小金井店' },
		],
	},
	{
		id: 7, name: '神奈川県 (83)',
		children: [
			{ id: 8, name: '吉祥寺店' },
			{ id: 9, name: '三鷹店' },
			{ id: 10, name: '武蔵境店' },
		],
	},
];
// 매장그룹 생성 공유유저 샘플데이터
export const ShareUserTestData = [
	{ name: '田中', email: 'test1@gmail.com' },
	{ name: '山田', email: 'test2@gmail.com' },
	{ name: '佐藤', email: 'test3@gmail.com' },
	{ name: '渡辺', email: 'test4@gmail.com' },
];
// 매장그룹 차트 샘플데이터
export const GroupTestCartData = {
	labels: ["07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00"
		, "15:00", "16:00", "17:00", "20:00", "21:00", "22:00", "23:00", "24:00" ],
	datasets: [
		{
			backgroundColor: "#CFCF39",
			data: [385, 526, 735, 832, 874, 921, 964, 995, 1023, 1067, 1274, 1467,
				864, 424, 534, 421],
			borderWidth: 0,
			borderColor: 'transparent',
			hoverOffset: 10
		},
		{
			backgroundColor: "#60BC99",
			data: [163, 637, 832, 953, 632, 1025, 1267, 1352, 1279, 1798, 732, 621,
				789, 425, 325, 189],
			borderWidth: 0,
			borderColor: 'transparent',
			hoverOffset: 10
		},
	]
};
// 매장그룹 카메라 샘플데이터
export const GroupTestCameraList = [
	{ cameraName : '吉祥寺店 入り口カメラ', imgUrl: 'test_image.png' },
	{ cameraName: '吉祥寺店 ２階東カメラ', imgUrl: 'test_store_image1.png' },
	{ cameraName: '吉祥寺店 ２階トイレ前カメラ', imgUrl: 'test_store_image2.png' },
	{ cameraName: '中野店 出口カメラ', imgUrl: 'test_store_image3.png' },
	{ cameraName: '中野店 A000010カメラ', imgUrl: 'test_thumbnail0.png' },
	{ cameraName: '中野店 2階窓側カメラ', imgUrl: 'test_thumbnail1.png' },
	{ cameraName: '荻窪店 入り口カメラ', imgUrl: 'test_thumbnail2.png' },
	{ cameraName : '荻窪店 窓側カメラ', imgUrl: 'test_image.png' },
	{ cameraName: '荻窪店 カウンター前カメラ', imgUrl: 'test_store_image1.png' },
	{ cameraName: '三鷹店 入り口カメラ', imgUrl: 'test_store_image2.png' },
	{ cameraName: '吉祥寺南店 レジ前', imgUrl: 'test_store_image3.png' },
	{ cameraName: '吉祥寺南店 レジ前', imgUrl: 'test_thumbnail0.png' },
	{ cameraName: '吉祥寺南店 レジ前', imgUrl: 'test_thumbnail2.png' },
	{ cameraName : '吉祥寺南店 入り口', imgUrl: 'test_image.png' },
	{ cameraName: '吉祥寺南店 レジ前', imgUrl: 'test_store_image1.png' },
	{ cameraName: '吉祥寺南店 レジ前', imgUrl: 'test_store_image2.png' },
];
// 매장리스트 트리뷰 샘플데이터(썸네일 표시 데이터)
export const ImageTreeviewTestStoreData = [
	{
		id: 0, name: '全店舗',
	},
	{
		id: 1, name: '東京都都下 (132)',
		children: [
			{ id: 2, name: '吉祥寺店' },
			{ id: 3, name: '三鷹店' },
			{ id: 4, name: '武蔵境店' },
			{ id: 5, name: '東小金井店' },
			{ id: 6, name: '武蔵小金井店' },
			{ id: 11, name: 'test', 
				children: [
					{ id: 12, image: 'test', name: '入り口カメラ'},
					{ id: 13, image: 'test', name: '2階東カメラ'},
					{ id: 14, image: 'test', name: '２階通路カメラ'},
					{ id: 15, image: 'test', name: 'トイレ前カメラ'},
				]
			}
		],
	},
	{
		id: 7, name: '神奈川県 (83)',
		children: [
			{ id: 8, name: '吉祥寺店' },
			{ id: 9, name: '三鷹店' },
			{ id: 10, name: '武蔵境店' },
		],
	},
];
// 정보(알람) 샘플데이터
export const NotiTestData = [
	{ 
		date: "2022年10月15日 月曜日",
		notificationList: [
			{ 
				time: '21:30',
				title: '테스트 103번 text'
			},
			{ 
				time: '12:50',
				title: '테스트 102번 text'
			},
			{ 
				time: '05:17',
				title: '테스트 101번 text'
			}
		]
	},
	{ date: "2022年10月14日 日曜日",
		notificationList: [
			{ 
				time: '22:51',
				title: '테스트 203번 text'
			},
			{ 
				time: '21:47',
				title: '테스트 202번 text'
			},
			{
				time: '16:21',
				title: '테스트 201번 text'
			}
		]
	},
	{ date: "2022年10月13日 土曜日",
		notificationList: [
			{ 
				time: '17:17',
				title: '테스트 304번 text'
			},
			{ 
				time: '14:25',
				title: '테스트 303번 text'
			},
			{ 
				time: '13:38',
				title: '테스트 302번 text'
			},
			{
				time: '12:51',
				title: '테스트 301번 text'
			}
		]
	},
	{ 
		date: "2022年10月13日 金曜日",
		notificationList: [
			{ 
				time: '20:33',
				title: '테스트 403번 text'
			},
			{ 
				time: '11:42',
				title: '테스트 402번 text'
			},
			{ 
				time: '02:36',
				title: '테스트 401번 text'
			}
		]
	},
];
// 카메라상태 샘플데이터
export const CameraStatusTestData = [
	{
		name: "新宿店",
		detailList: [
			{
				cameraName: "A000001",
				date: "2022/01/20 10:30",
				uau: "BU101234567",
				status: true
			},
			{
				cameraName: "A000002",
				date: "2022/01/20 10:30",
				uau: "BU201234567",
				status: false
			},
			{
				cameraName: "A000003",
				date: "2022/01/20 10:30",
				uau: "BU301234567",
				status: true
			}
		]
	},
	{
		name: "高円寺",
		detailList: [
			{
				cameraName: "B000001",
				date: "2022/01/20 10:30",
				uau: "BU101234567",
				status: true
			},
			{
				cameraName: "B000002",
				date: "2022/01/20 10:30",
				uau: "BU201234567",
				status: false
			},
			{
				cameraName: "B000003",
				date: "2022/01/20 10:30",
				uau: "BU301234567",
				status: false
			}
		]
	}
];
// 설정 - 점포지점검색 결과
export const TestBranchStoreData = [
	{
		area: '東京都杉並区',
		storeCnt: 3,
		stores: [
			{ storeId: 1, storeName: '荻窪店', admin: '山田太郎', shareUser: '8' },
			{ storeId: 1, storeName: '高円寺南ロ店', admin: '(未登録)', shareUser: '(未登録)' },
			{ storeId: 1, storeName: '西荻窪店', admin: '渡邊一郎', shareUser: '5' },
		]
	},
	{
		area: '東京都武蔵野市',
		storeCnt: 3,
		stores: [
			{ storeId: 1, storeName: '吉祥寺南ロ店', admin: '山田太郎', shareUser: '8' },
			{ storeId: 1, storeName: '武蔵境店', admin: '田中一郎', shareUser: '6' },
			{ storeId: 1, storeName: '関前店', admin: '渡邊一郎', shareUser: '5' },
		]
	},
	{
		area: '東京都三鷹市',
		storeCnt: 3,
		stores: [
			{ storeId: 1, storeName: '下連雀4丁目店', admin: '山田太郎', shareUser: '8' },
			{ storeId: 1, storeName: '北町店', admin: '(未登録)', shareUser: '12' },
			{ storeId: 1, storeName: '上連雀1丁目店', admin: '渡邊一郎', shareUser: '5' },
		]
	},
];

// 방문인수 샘플데이터
export const peopleData = {
	labels: ['85%', '89%', '86%', '91%', '93%', '76%', '78%', '86%', '91%', '88%'],
	datasets: [
		{
			backgroundColor: "#CFCF39",
			data: [28700, 29800, 34800, 33300, 34800, 34800, 34800, 34800, 34800, 34800],
			borderWidth: 0,
			borderColor: 'transparent',
			barThickness: 35,
			hoverOffset: 0
		},
		{
			backgroundColor: "#9A9A9A",
			data: [28700, 29800, 34800, 33300, 29800, 29800, 29800, 29800, 29800, 29800],
			borderWidth: 0,
			borderColor: 'transparent',
			barThickness: 35,
			hoverOffset: 0
		},
	]
};

// 남녀 연령대 별 샘플데이터
export const peopleData1 = {
	labels: ['202108', '202109', '202110', '202111', '202112', '202101', '202102', '202103', '202104', '202105'],
	datasets: [
		{
			backgroundColor: "#3995CF",
			data: [28700, 29800, 34800, 33300, 0, 0, 0, 0, 0, 0],
			borderWidth: 0,
			borderColor: 'transparent',
			barThickness: 35,
			hoverOffset: 10
		},
		{
			backgroundColor: "#DE6485",
			data: [28700, 29800, 34800, 33300, 0, 0, 0, 0, 0, 0],
			borderWidth: 0,
			borderColor: 'transparent',
			barThickness: 35,
			hoverOffset: 10
		},
	]
};

// 신규 단골손님 별 샘플데이터
export const peopleData2 = {
	labels: ['202108', '202109', '202110', '202111', '202112', '202101', '202102', '202103', '202104', '202105'],
	datasets: [
		{
			backgroundColor: "#8864A7",
			data: [28700, 29800, 34800, 33300, 0, 0, 0, 0, 0, 0],
			borderWidth: 0,
			borderColor: 'transparent',
			barThickness: 35,
			hoverOffset: 10
		},
		{
			backgroundColor: "#60BC99",
			data: [28700, 29800, 34800, 33300, 0, 0, 0, 0, 0, 0],
			borderWidth: 0,
			borderColor: 'transparent',
			barThickness: 35,
			hoverOffset: 10,
		},
	]
};

// 날씨 샘플데이터
export const weatherSampleData = [
	{weather: "晴れ", weather_cd: "100", max_temperature: "18", rainy: "10", min_temperature: "12"},
	{weather: "雨", weather_cd: "300", max_temperature: "16", rainy: "50", min_temperature: "12"},
	{weather: "雨", weather_cd: "300", max_temperature: "5", rainy: "100", min_temperature: "4"},
	{weather: "晴れ", weather_cd: "100", max_temperature: "14", rainy: "90", min_temperature: "9"},
	{weather: "くもり", weather_cd: "200", max_temperature: "11", rainy: "30", min_temperature: "9"},
	{weather: "晴れ", weather_cd: "100", max_temperature: "3", rainy: "50", min_temperature: "2"},
	{weather: "雨", weather_cd: "300", max_temperature: "9", rainy: "40", min_temperature: "6"},
	{weather: "晴れ", weather_cd: "100", max_temperature: "13", rainy: "20", min_temperature: "10"},
	{weather: "くもり", weather_cd: "200", max_temperature: "15", rainy: "0", min_temperature: "13"},
	{weather: "晴れ 時々 くもり", weather_cd: "101", max_temperature: "19", rainy: "10", min_temperature: "9"}
];

// 설정 > 알림설정의 샘플데이터
export const testNotificationSettingData = [
	{
		name: "新宿店",
		allDisconnectedPush: false,
		allDisconnectedEmail: false,
		allMotionDetectPush: false,
		allMotionDetectEmail: false,
		allSoundDetectPush: false,
		allSoundDetectEmail: false,
		cameraList: [
			{
				name: 'A000001',
				disconnectedPush: false,
				disconnectedEmail: false,
				motionDetectPush: false,
				motionDetectEmail: false,
				soundDetectPush: false,
				soundDetectEmail: false,
			},
			{
				name: 'A000002',
				disconnectedPush: false,
				disconnectedEmail: false,
				motionDetectPush: false,
				motionDetectEmail: false,
				soundDetectPush: false,
				soundDetectEmail: false,
			},
			{
				name: 'A000003',
				disconnectedPush: false,
				disconnectedEmail: false,
				motionDetectPush: false,
				motionDetectEmail: false,
				soundDetectPush: false,
				soundDetectEmail: false,
			},
		]
	},
	{
		name: "高円寺店",
		allDisconnectedPush: false,
		allDisconnectedEmail: false,
		allMotionDetectPush: false,
		allMotionDetectEmail: false,
		allSoundDetectPush: false,
		allSoundDetectEmail: false,
		cameraList: [
			{
				name: 'A000001',
				disconnectedPush: false,
				disconnectedEmail: false,
				motionDetectPush: false,
				motionDetectEmail: false,
				soundDetectPush: false,
				soundDetectEmail: false,
			},
			{
				name: 'A000002',
				disconnectedPush: false,
				disconnectedEmail: false,
				motionDetectPush: false,
				motionDetectEmail: false,
				soundDetectPush: false,
				soundDetectEmail: false,
			},
		]
	},
	{
		name: "荻窪店",
		allDisconnectedPush: false,
		allDisconnectedEmail: false,
		allMotionDetectPush: false,
		allMotionDetectEmail: false,
		allSoundDetectPush: false,
		allSoundDetectEmail: false,
		cameraList: [
			{
				name: 'A000001',
				disconnectedPush: false,
				disconnectedEmail: false,
				motionDetectPush: false,
				motionDetectEmail: false,
				soundDetectPush: false,
				soundDetectEmail: false,
			},
			{
				name: 'A000002',
				disconnectedPush: false,
				disconnectedEmail: false,
				motionDetectPush: false,
				motionDetectEmail: false,
				soundDetectPush: false,
				soundDetectEmail: false,
			},
			{
				name: 'A000003',
				disconnectedPush: false,
				disconnectedEmail: false,
				motionDetectPush: false,
				motionDetectEmail: false,
				soundDetectPush: false,
				soundDetectEmail: false,
			},
		]
	},
];